export default __webpack_public_path__ + "static/media/clio-rs-medium2.34c9b6cc.jpg";